import React from "react";
import { Loop, Odometer } from "./primitives";

/* Bespoke dark mock-UI artwork for the ABA Billing Platform template — all animated via the
 * `Loop`/`Odometer` primitives (no images). Styling is class-based (`.abp-*` / `.abp-o*` in
 * abaBillingPlatformStyles.scss). Copy that varies per page comes through props (hero); the
 * mock data inside the cards is illustrative and intentionally hard-coded. */

/** Hero: copy column + the 3-panel cycling mock-UI card (appointments → claims → receivables). */
export const Hero = ({ hero, ctaHref, demoHref }) => {
  return (
    <header data-screen-label="Hero" className="abp-hero">
      <div className="abp-hero__col">
        <Loop anim="tlglow" dur={3.5} className="abp-badge">
          <span className="abp-badge__a"><span className="abp-badge__diamond"></span>{hero.badgeA}</span>
          <span className="abp-badge__b">{hero.badgeB}</span>
        </Loop>

        <h1 className="abp-hero__title">{hero.titleLead}<em>{hero.titleAccent}</em></h1>

        <p className="abp-hero__subtitle">{hero.subtitle}</p>

        <div className="abp-hero__actions">
          <a href={ctaHref} target="_blank" rel="noopener noreferrer" className="abp-btn-primary">Start 2 months free <span className="abp-arrow">&rarr;</span></a>
          <a href={demoHref} target="_blank" rel="noopener noreferrer" className="abp-btn-ghost">Book a demo</a>
        </div>

        <div className="abp-hero__trust">
          {hero.trust.map((t, i) => (
            <span key={i} className="abp-hero__trust-item"><span className="abp-hero__trust-dot"></span>{t}</span>
          ))}
        </div>
      </div>

      {/* HERO ANIMATION: appointments -> claims -> receivables */}
      <div data-anim="yes" className="abp-herocard">
        <div className="abp-window">
          <span className="abp-window__dots"><span className="abp-dot abp-dot--red"></span><span className="abp-dot abp-dot--yellow"></span><span className="abp-dot abp-dot--green"></span></span>
          <div className="abp-tabs">
            <span className="abp-tab"><Loop anim="hp1o" dur={18} as="span" className="abp-tab__hl"></Loop><span className="abp-rel">Billable appointments</span></span>
            <span className="abp-tab"><Loop anim="hp2o" dur={18} as="span" className="abp-tab__hl"></Loop><span className="abp-rel">Pending claims</span></span>
            <span className="abp-tab"><Loop anim="hp3o" dur={18} as="span" className="abp-tab__hl"></Loop><span className="abp-rel">Receivables</span></span>
          </div>
        </div>

        <div className="abp-panels">
          {/* PANEL 1 */}
          <Loop anim="hp1" dur={18} className="abp-panel">
            <div className="abp-between abp-mb-12">
              <span className="abp-card-label">5 BILLABLE APPOINTMENTS</span>
              <span className="abp-selectall"><Loop anim="bx" dur={18} as="span" className="abp-check17"><Loop anim="tk" dur={18} as="svg" width="9" height="9" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></Loop></Loop>Select all</span>
            </div>

            <div className="abp-stack-7">
              <div className="abp-row">
                <Loop anim="bx" dur={18} as="span" className="abp-check17"><Loop anim="tk" dur={18} as="svg" width="9" height="9" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></Loop></Loop>
                <span className="abp-row__name">R. Alvarez</span>
                <span className="abp-cell abp-cell--w64">97153</span>
                <span className="abp-cell abp-cell--w52">4.0 hrs</span>
                <span className="abp-flagslot">
                  <Loop anim="fo" dur={18} as="span" className="abp-flag">!</Loop>
                  <Loop anim="fi" dur={18} as="span" className="abp-flagslot__ok"><svg width="11" height="11" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></Loop>
                </span>
              </div>
              <div className="abp-row">
                <Loop anim="bx" dur={18} as="span" className="abp-check17"><Loop anim="tk" dur={18} as="svg" width="9" height="9" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></Loop></Loop>
                <span className="abp-row__name">J. Ndiaye</span>
                <span className="abp-cell abp-cell--w64">97155</span>
                <span className="abp-cell abp-cell--w52">2.5 hrs</span>
                <span className="abp-check20"><svg width="11" height="11" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></span>
              </div>
              <div className="abp-row">
                <Loop anim="bx" dur={18} as="span" className="abp-check17"><Loop anim="tk" dur={18} as="svg" width="9" height="9" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></Loop></Loop>
                <span className="abp-row__name">M. Osei</span>
                <span className="abp-cell abp-cell--w64">97153</span>
                <span className="abp-cell abp-cell--w52">3.0 hrs</span>
                <span className="abp-flagslot">
                  <Loop anim="fo" dur={18} as="span" className="abp-flag">!</Loop>
                  <Loop anim="fi" dur={18} as="span" className="abp-flagslot__ok"><svg width="11" height="11" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></Loop>
                </span>
              </div>
              <div className="abp-row">
                <Loop anim="bx" dur={18} as="span" className="abp-check17"><Loop anim="tk" dur={18} as="svg" width="9" height="9" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></Loop></Loop>
                <span className="abp-row__name">T. Brooks</span>
                <span className="abp-cell abp-cell--w64">97158</span>
                <span className="abp-cell abp-cell--w52">1.5 hrs</span>
                <span className="abp-check20"><svg width="11" height="11" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></span>
              </div>
              <div className="abp-row">
                <Loop anim="bx" dur={18} as="span" className="abp-check17"><Loop anim="tk" dur={18} as="svg" width="9" height="9" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></Loop></Loop>
                <span className="abp-row__name">L. Grant</span>
                <span className="abp-cell abp-cell--w64">97153</span>
                <span className="abp-cell abp-cell--w52">2.0 hrs</span>
                <span className="abp-check20"><svg width="11" height="11" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></span>
              </div>
            </div>

            <div className="abp-panel__foot">
              <Loop anim="pl" dur={2.4} as="span" className="abp-panel__issues">2 issues flagged &mdash; fixed in place</Loop>
              <Loop anim="pr" dur={18} as="span" className="abp-panel__btn">Generate claims</Loop>
            </div>
          </Loop>

          {/* PANEL 2 */}
          <Loop anim="hp2" dur={18} className="abp-panel--abs">
            <div className="abp-panel__label">4 PENDING CLAIMS &middot; READY TO SUBMIT</div>
            <div className="abp-stack-7">
              <div className="abp-row"><span className="abp-check-sm"><svg width="9" height="9" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></span><span className="abp-row__name">#48291 &middot; R. Alvarez</span><span className="abp-money">$1,240</span></div>
              <div className="abp-row"><span className="abp-check-sm"><svg width="9" height="9" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></span><span className="abp-row__name">#48292 &middot; J. Ndiaye</span><span className="abp-money">$775</span></div>
              <div className="abp-row"><span className="abp-check-sm"><svg width="9" height="9" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></span><span className="abp-row__name">#48293 &middot; M. Osei</span><span className="abp-money">$930</span></div>
            </div>

            <div className="abp-panel__label2">CHOOSE CLEARINGHOUSE</div>
            <div className="abp-wrap8">
              <span className="abp-chip">Availity</span>
              <span className="abp-chip">Office Ally</span>
              <Loop anim="ch" dur={18} as="span" className="abp-chip-active">TherapyLake clearinghouse</Loop>
            </div>

            <div className="abp-panel__foot2">
              <div className="abp-flex1">
                <div className="abp-progress"><Loop anim="pg" dur={18} className="abp-progress__fill"></Loop></div>
                <div className="abp-hint">Transmitting to payers&hellip;</div>
              </div>
              <Loop anim="pr2" dur={18} as="span" className="abp-panel__btn2">Submit all</Loop>
            </div>
          </Loop>

          {/* PANEL 3 */}
          <Loop anim="hp3" dur={18} className="abp-panel--abs">
            <div className="abp-between abp-mb-12">
              <span className="abp-card-label">RECEIVABLES</span>
              <span className="abp-tag-green">LIVE STATUS</span>
            </div>
            <div className="abp-stack-7">
              <Loop anim="r1" dur={18} className="abp-recv-row"><span className="abp-row__name">#48291 &middot; Aetna</span><span className="abp-tag-green">PAID</span><span className="abp-money-right">$1,240</span></Loop>
              <Loop anim="r2" dur={18} className="abp-recv-row"><span className="abp-row__name">#48292 &middot; Anthem</span><span className="abp-tag-amber">IN PROCESS</span><span className="abp-money-right">$775</span></Loop>
              <Loop anim="r3" dur={18} className="abp-recv-row"><span className="abp-row__name">#48293 &middot; Cigna</span><span className="abp-tag-red">APPEAL FILED</span><span className="abp-money-right">$930</span></Loop>
            </div>
            <div className="abp-row9 abp-mt-auto">
              <div className="abp-tile abp-tile--navy"><div className="abp-stat-label abp-stat-label--muted">COLLECTED</div><div className="abp-stat-value abp-stat-value--white">$2,945</div></div>
              <div className="abp-tile abp-tile--white"><div className="abp-stat-label abp-stat-label--slate">OUTSTANDING</div><div className="abp-stat-value abp-stat-value--navy">$1,705</div></div>
              <div className="abp-tile abp-tile--white"><div className="abp-stat-label abp-stat-label--slate">DAYS IN A/R</div><div className="abp-stat-value abp-stat-value--green">21</div></div>
            </div>
          </Loop>
        </div>
      </div>
    </header>
  );
};

/** S1 — guardrails: warnings caught on the claim + at scheduling. */
export const Guardrails = () => {
  return (
    <div data-anim="yes" className="abp-card abp-card--stack">
      <div className="abp-card-label">GUARDRAILS ON THIS CLAIM</div>
      <div className="abp-stack-9">
        <div className="abp-warn abp-warn--orange"><span className="abp-warn-icon abp-warn-icon--orange">!</span><div><div className="abp-warn-title abp-warn-title--orange">Authorization units exceeded</div><div className="abp-warn-sub">120 of 120 units used &mdash; blocked before submission</div></div></div>
        <Loop anim="pc2" dur={9} className="abp-warn abp-warn--amber"><span className="abp-warn-icon abp-warn-icon--amber">!</span><div><div className="abp-warn-title abp-warn-title--amber">Incomplete units on session</div><div className="abp-warn-sub">Session note logged 3.0 hrs, appointment shows 4.0</div></div></Loop>
        <Loop anim="pc3" dur={9} className="abp-warn abp-warn--amber"><span className="abp-warn-icon abp-warn-icon--amber">!</span><div><div className="abp-warn-title abp-warn-title--amber">Missing signed note</div><div className="abp-warn-sub">Note unsigned &mdash; claim held automatically</div></div></Loop>
      </div>

      <div className="abp-guard-label2">&hellip;AND AT SCHEDULING</div>
      <div className="abp-navy-card">
        <div className="abp-flex-10">
          <Loop anim="pl" dur={2.2} as="span" className="abp-guard-alert">!</Loop>
          <div className="abp-flex1">
            <div className="abp-guard-title">New appointment &mdash; Mar 14, 4:00 PM</div>
            <div className="abp-guard-sub">Warning shown while the appointment is created</div>
          </div>
        </div>
        <div className="abp-wrap8-mt">
          <span className="abp-guard-chip-orange">Auth expires in 3 days</span>
          <span className="abp-guard-chip-amber">Only 6 units remaining</span>
        </div>
      </div>
    </div>
  );
};

/** S2 — shaped by RCM agents: avatars + shipped roadmap. */
export const RcmAgents = () => {
  return (
    <div data-anim="yes" className="abp-card">
      <div className="abp-ag-label">SHAPED BY THE PEOPLE WHO BILL</div>
      <div className="abp-ag-avatars">
        <span className="abp-ag-av1">RM</span>
        <span className="abp-ag-av2">SK</span>
        <span className="abp-ag-av3">DP</span>
        <span className="abp-ag-av4">+9</span>
        <span className="abp-ag-count">RCM agents on the product</span>
      </div>
      <div className="abp-stack-9">
        <div className="abp-ag-row"><span className="abp-ag-rowlabel">Denial-reason auto-tagging</span><span className="abp-status-shipped">SHIPPED</span></div>
        <div className="abp-ag-row"><span className="abp-ag-rowlabel">Batch ERA reconciliation</span><span className="abp-toggle82"><Loop anim="e2o" dur={10} as="span" className="abp-status-prog">IN PROGRESS</Loop><Loop anim="e2i" dur={10} as="span" className="abp-status-ship-abs">SHIPPED</Loop></span></div>
        <div className="abp-ag-row"><span className="abp-ag-rowlabel">Smart follow-up queue</span><span className="abp-toggle82"><Loop anim="e3o" dur={10} as="span" className="abp-status-prog">IN PROGRESS</Loop><Loop anim="e3i" dur={10} as="span" className="abp-status-ship-abs">SHIPPED</Loop></span></div>
      </div>
      <div className="abp-ag-foot"><span className="abp-ag-foottext">Requests from billing teams, shipped</span><span className="abp-ag-footaccent">every release</span></div>
    </div>
  );
};

/** S3 — automated payment posting: ERA applied to claims with odometers. */
export const PaymentPosting = () => {
  return (
    <div data-anim="yes" className="abp-card">
      <div className="abp-card-label abp-mb-13">PAYMENT RECEIVED &middot; APPLY TO CLAIMS</div>
      <div className="abp-pay-card">
        <span className="abp-pay-badge">$</span>
        <div className="abp-flex1">
          <div className="abp-pay-title">Anthem &mdash; check #90412</div>
          <div className="abp-sub-navy">ERA received &amp; matched automatically</div>
        </div>
        <div className="abp-pay-amount">$5,000</div>
      </div>

      <div className="abp-pay-header">
        <span className="abp-card-label">CLAIMS ADDED</span>
        <span className="abp-pay-add">+ Add claims</span>
      </div>
      <div className="abp-stack-8">
        <div className="abp-row-lg"><span className="abp-check20"><svg width="11" height="11" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></span><span className="abp-row__name">#48292 &middot; J. Ndiaye</span><span className="abp-money">$1,850</span></div>
        <Loop anim="pc2" dur={11} className="abp-row-lg"><span className="abp-check20"><svg width="11" height="11" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></span><span className="abp-row__name">#48307 &middot; M. Osei</span><span className="abp-money">$2,150</span></Loop>
        <Loop anim="pc3" dur={11} className="abp-row-lg"><span className="abp-check20"><svg width="11" height="11" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></span><span className="abp-row__name">#48311 &middot; T. Brooks</span><span className="abp-money">$1,000</span></Loop>
      </div>

      <div className="abp-pay-tiles">
        <div className="abp-tile abp-tile--green">
          <div className="abp-stat-label abp-stat-label--green">APPLIED</div>
          <Odometer size={26} dur={11} mt={2} tones="green-deep" rows={["$0", "$1,850", "$4,000", "$5,000", "$5,000"]} />
        </div>
        <div className="abp-tile abp-tile--white">
          <div className="abp-stat-label abp-stat-label--slate">UNAPPLIED</div>
          <Odometer size={26} dur={11} mt={2} tones={["navy", "navy", "navy", "green", "green"]} rows={["$5,000", "$3,150", "$1,000", "$0", "$0"]} />
        </div>
      </div>
    </div>
  );
};

/** S4 — eligibility checks before services are rendered. */
export const Eligibility = () => {
  return (
    <div data-anim="yes" className="abp-card">
      <div className="abp-between abp-mb-13">
        <span className="abp-card-label">CLIENTS &middot; ELIGIBILITY</span>
        <span className="abp-tag-green">RUNS WEEKLY</span>
      </div>
      <div className="abp-stack-8">
        <div className="abp-row-lg"><span className="abp-row__name">R. Alvarez</span><span className="abp-cell abp-cell--w74">Aetna PPO</span><span className="abp-stwrap22"><span className="abp-dashed abp-op0"></span><span className="abp-circle-check"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></span></span></div>
        <div className="abp-row-lg"><span className="abp-row__name">J. Ndiaye</span><span className="abp-cell abp-cell--w74">Anthem</span><span className="abp-stwrap22"><Loop anim="e2o" dur={12} as="span" className="abp-dashed"></Loop><Loop anim="e2i" dur={12} as="span" className="abp-circle-check"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg></Loop></span></div>
        <div className="abp-el-warnrow"><span className="abp-row__name">M. Osei</span><span className="abp-el-payer">Cigna</span><span className="abp-stwrap22"><Loop anim="e3o" dur={12} as="span" className="abp-dashed"></Loop><Loop anim="e3i" dur={12} as="span" className="abp-el-fail"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M18 6 6 18M6 6l12 12" stroke="#fff" strokeWidth="4" strokeLinecap="round"/></svg></Loop></span></div>
      </div>

      <div className="abp-white-card">
        <div className="abp-flex-12">
          <span className="abp-el-avatar">MO</span>
          <div className="abp-flex1"><div className="abp-item-title">M. Osei</div><div className="abp-el-sub">Client profile &middot; Cigna</div></div>
          <span className="abp-el-btn">Check eligibility</span>
        </div>
        <div className="abp-el-alertrow">
          <span className="abp-el-alerticon">!</span>
          <span className="abp-el-alerttext">Not eligible &mdash; coverage ended Mar 1. Sessions held before they happen.</span>
        </div>
      </div>
    </div>
  );
};

/** S5 — reports & KPIs: odometer tiles + A/R aging bars. */
export const KpiReceivables = () => {
  return (
    <div data-anim="yes" className="abp-card">
      <div className="abp-card-label abp-mb-13">BILLING KPIs &middot; MONTH TO DATE</div>
      <div className="abp-row9 abp-mb-11">
        <div className="abp-tile abp-tile--lg abp-tile--navy">
          <div className="abp-stat-label abp-stat-label--muted">BILLED</div>
          <Odometer size={28} dur={9} mt={3} tones="white" rows={["$0", "$112K", "$228K", "$309K", "$342K"]} />
        </div>
        <div className="abp-tile abp-tile--lg abp-tile--green">
          <div className="abp-stat-label abp-stat-label--green">COLLECTED</div>
          <Odometer size={28} dur={9} mt={3} tones="green-deep" rows={["$0", "$96K", "$204K", "$287K", "$331K"]} />
        </div>
      </div>
      <div className="abp-row9">
        <div className="abp-tile abp-tile--lg abp-tile--white">
          <div className="abp-stat-label abp-stat-label--slate">AVG DAYS IN A/R</div>
          <Odometer size={28} dur={9} mt={3} tones={["navy", "navy", "navy", "navy", "green"]} rows={["44", "37", "29", "24", "19"]} />
        </div>
        <div className="abp-tile abp-tile--lg abp-tile--white">
          <div className="abp-stat-label abp-stat-label--slate">% COLLECTED</div>
          <Odometer size={28} dur={9} mt={3} tones={["navy", "navy", "navy", "navy", "green"]} rows={["61%", "74%", "86%", "94%", "100%"]} />
        </div>
      </div>

      <div className="abp-kpi-aging">
        <div className="abp-between abp-mb-13"><span className="abp-item-name">A/R aging</span><span className="abp-kpi-agingsub">days outstanding</span></div>
        <div className="abp-kpi-bars">
          <div className="abp-kpi-barcol"><Loop anim="bhF" dur={9} className="abp-kpi-bar1"></Loop><span className="abp-kpi-barlabel">0&ndash;30</span></div>
          <div className="abp-kpi-barcol"><Loop anim="bhF" dur={9} className="abp-kpi-bar2"></Loop><span className="abp-kpi-barlabel">31&ndash;60</span></div>
          <div className="abp-kpi-barcol"><Loop anim="bhF" dur={9} className="abp-kpi-bar3"></Loop><span className="abp-kpi-barlabel">61&ndash;90</span></div>
          <div className="abp-kpi-barcol"><Loop anim="bhF" dur={9} className="abp-kpi-bar4"></Loop><span className="abp-kpi-barlabel">90+</span></div>
        </div>
      </div>
    </div>
  );
};

/** S6 — connected: authorization utilization traced to a claim. */
export const AuthUtilization = () => {
  return (
    <div data-anim="yes" className="abp-card">
      <div className="abp-card-label abp-mb-13">AUTHORIZATION UTILIZATION</div>
      <div className="abp-au-card">
        <div className="abp-au-header">
          <div><div className="abp-item-title">Auth #A-7741 &middot; R. Alvarez</div><div className="abp-au-dates">Feb 1 &ndash; Apr 30 &middot; 120 units</div></div>
          <Odometer size={32} dur={10} align tones={["navy", "navy", "navy", "navy", "green"]} rows={["12%", "34%", "58%", "71%", "86%"]} />
        </div>
        <div className="abp-au-track"><Loop anim="bwF" dur={10} className="abp-au-fill"></Loop></div>
        <div className="abp-au-daterow">
          <span className="abp-au-date">Mar 10</span>
          <Loop anim="pc2" dur={10} as="span" className="abp-au-date">Mar 12</Loop>
          <Loop anim="pc3" dur={10} as="span" className="abp-au-date">Mar 14</Loop>
          <span className="abp-au-date-muted">Mar 17</span>
        </div>
        <div className="abp-au-hint">Utilization updates as sessions are rendered</div>
      </div>

      <div className="abp-au-chain">
        <div className="abp-au-node"><span className="abp-au-badge1">AU</span><span className="abp-item-name">Authorization</span><span className="abp-au-status">VALID</span></div>
        <div className="abp-au-connector"></div>
        <div className="abp-au-node"><span className="abp-au-badge2">SN</span><span className="abp-item-name">Session &amp; signed note</span><span className="abp-au-status">LINKED</span></div>
        <div className="abp-au-connector"></div>
        <div className="abp-au-node--claim"><span className="abp-au-badge3">$</span><span className="abp-au-claimtext">Claim #48291</span><span className="abp-au-status-accent">TRACEABLE</span></div>
      </div>
    </div>
  );
};
